import React from 'react';
import * as types from './constants';
import { put } from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {history} from '~/router/history';
import {generatePath} from 'react-router';
import CloseIcon from '@material-ui/icons/Close';

export const openSidebar = () => ({
    type: types.LAYOUT_SIDEBAR_OPEN,
});
export const closeSidebar = () => ({
    type: types.LAYOUT_SIDEBAR_CLOSE,
});
export const toggleSubMenu = (name) => ({
    type: types.TOGGLE_SUB_MENU,
    name: name
})
export const openPreloader = () => ({
    type: types.LAYOUT_PRELOADER_OPEN,
});
export const closePreloader = () => ({
    type: types.LAYOUT_PRELOADER_CLOSE,
});

export function* openPreloaderSaga() {
    yield put({
        type: types.LAYOUT_PRELOADER_OPEN,
        data: {}
    })
};
export function* closePreloaderSaga() {
    yield put({
        type: types.LAYOUT_PRELOADER_CLOSE,
        data: {}
    })
};
export function* closeModalWindow(data) {
    yield put({
        ...data,
        type: types.MODAL_WINDOW_CLOSE,
    })
};

export function* showMessageSaga(action) {
    let {notification_id = null, toast: {type = 'success', message, link = null}} = action;
    toast[type](message, {
        // onClose: (data) => {
        //     console.log('onClose');
        //     console.log('data = ', data);
        //     if (notification_id) {
        //         markAsReadNotifications([notification_id]);
        //     }
        // },
        onClick: (e) => {
            if (notification_id) {
                markAsReadNotifications([notification_id]);
            }
            if (link) {
                history.push(generatePath(link));
            }
        }
    });

    // toast.success(message);
    // toast.info(message);
    // toast.warn(message);
    // toast.error(message);
    // toast[action.message.type](action.message.text)
};

export const onMouseOverSidebar = () => ({
    type: types.LAYOUT_MOUSE_OVER_SIDEBAR,
});
export const onMouseLeaveSidebar = () => ({
    type: types.LAYOUT_MOUSE_LEAVE_SIDEBAR,
});
export const onMouseOverOpenedSidebar = () => ({
    type: types.LAYOUT_MOUSE_OVER_OPENED_SIDEBAR
})
export const onMouseLeaveOpenedSidebar = () => ({
    type: types.LAYOUT_MOUSE_LEAVE_OPENED_SIDEBAR
})

export const markAsReadNotifications = (notifications) => ({
    types: [
        types.MARK_AS_READ_NOTIFICATIONS_REQUEST,
        types.MARK_AS_READ_NOTIFICATIONS_SUCCESS,
        types.MARK_AS_READ_NOTIFICATIONS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/user/notifications/mark-as-read`,
            method: 'POST',
            body: {notifications: notifications}
        }),
});
